import { render, staticRenderFns } from "./pass_colors.vue?vue&type=template&id=0adf15eb&"
import script from "./pass_colors.vue?vue&type=script&lang=js&"
export * from "./pass_colors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports